export default "__VITE_ASSET__g9Yp6oRmkqkn9cGwcNsiTw__"